/**
 * XSS Protection Utility
 * Sanitizes user input to prevent Cross-Site Scripting (XSS) attacks
 */

export const sanitizeInput = (input) => {
  if (typeof input !== 'string') return input;
  return input
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#x27;');
};

/**
 * Sanitizes an object by recursively sanitizing all string properties
 */
export const sanitizeObject = (obj) => {
  if (typeof obj !== 'object' || obj === null) return obj;
  
  if (Array.isArray(obj)) {
    return obj.map(item => sanitizeObject(item));
  }
  
  const sanitized = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (typeof obj[key] === 'string') {
        sanitized[key] = sanitizeInput(obj[key]);
      } else if (typeof obj[key] === 'object') {
        sanitized[key] = sanitizeObject(obj[key]);
      } else {
        sanitized[key] = obj[key];
      }
    }
  }
  
  return sanitized;
};

/**
 * Unescapes HTML entities back to raw characters
 */
export const unescapeHTML = (str) => {
  if (typeof str !== 'string') return str;
  return str
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#x27;/g, "'")
    .replace(/&#x2F;/g, '/');
};

/**
 * Sanitizes CSV/Excel exported values to prevent formula injection (BUG-USR-004)
 * Prefixes strings beginning with =, +, -, @, \t, or \r with a single quote (')
 */
export const sanitizeCsvFormula = (val) => {
  if (val === null || val === undefined) return '';
  const str = String(val);
  if (/^[-+=@\t\r]/.test(str)) {
    return "'" + str;
  }
  return str;
};

